import { useEffect } from "react";

const SCROLLING_ATTRIBUTE = "data-scrollbar-scrolling";
const SCROLL_END_DELAY_MS = 1000;

function getScrollElement(target) {
  if (target === document) return document.body;
  return target instanceof Element ? target : null;
}

export default function useActiveScrollbarVisibility() {
  useEffect(() => {
    const scrollEndTimers = new Map();

    const handleScroll = (event) => {
      const scrollElement = getScrollElement(event.target);
      if (!scrollElement) return;

      scrollElement.setAttribute(SCROLLING_ATTRIBUTE, "true");

      const existingTimer = scrollEndTimers.get(scrollElement);
      if (existingTimer) window.clearTimeout(existingTimer);

      const timer = window.setTimeout(() => {
        scrollElement.removeAttribute(SCROLLING_ATTRIBUTE);
        scrollEndTimers.delete(scrollElement);
      }, SCROLL_END_DELAY_MS);

      scrollEndTimers.set(scrollElement, timer);
    };

    document.addEventListener("scroll", handleScroll, true);

    return () => {
      document.removeEventListener("scroll", handleScroll, true);
      scrollEndTimers.forEach((timer, scrollElement) => {
        window.clearTimeout(timer);
        scrollElement.removeAttribute(SCROLLING_ATTRIBUTE);
      });
    };
  }, []);
}
